import { Controller } from '@hotwired/stimulus'

// "Send test" on a Notifications row: emails the address typed in that row, saved or not. Its own
// controller rather than packs/restaurant/test_email.js, which wires only the first list's Add button.
export default class extends Controller {
  static targets = ['email', 'button']

  async send() {
    if (!this.emailTarget.value.trim() || !this.emailTarget.checkValidity()) {
      this.emailTarget.reportValidity()
      return
    }

    this.buttonTarget.disabled = true
    try {
      const response = await fetch('/test_mailer', {
        method: 'POST',
        // XHR header: TestMailerController#create renders nothing, which Rails answers with 204 only for XHR.
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ email: this.emailTarget.value.trim() })
      })
      this.buttonTarget.textContent = response.ok ? 'Sent' : 'Try again'
    } catch (error) {
      this.buttonTarget.textContent = 'Try again'
    } finally {
      this.buttonTarget.disabled = false
    }
  }
}
